import { RootState } from '../../types/redux/states/RootState';

export const getApiError = ({ visitor }: RootState) => visitor.apiError;
